// extracted by mini-css-extract-plugin
export default {"header":"TableFixedPage_header__hbwI7","title":"TableFixedPage_title__znsqz"};